import React from 'react';

import * as styled from './styles';

type Props = {
  label: string;
  value: number;
  accentColor?: string;
};

export const RatingBar = ({ label, value, accentColor }: Props) => (
  <styled.Row>
    <styled.Label $accentColor={accentColor}>
      {label.replace(/_/g, ' ')}
    </styled.Label>
    <styled.Track>
      <styled.Fill $pct={(value / 5) * 100} $color={accentColor} />
    </styled.Track>
    <styled.Value $accentColor={accentColor}>{value.toFixed(1)}</styled.Value>
  </styled.Row>
);
